const clientDetails = {
    currentFollowUp: "currentFollowUp",
    futureFollowUp: "futureFollowUp",
}
  

  export {
    clientDetails
  }
  